import { useLayoutContext } from '../../../Context/Layout.context';
import { updateContactData } from '../../../services/support/contactData/contactData.service';
import { IContactData } from '../../../services/support/contactData/contactData.types';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { ContactDataEditor } from '../ContactDataEditor/ContactDataEditor.component';

interface EditContactDataProps {
  onClose: () => void;
  onChange: () => void;
  contactDataProp: IContactData;
}

export const EditContactData: React.FC<EditContactDataProps> = ({ onClose, onChange, contactDataProp: contactDataProp }) => {

  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();
  useDocumentTitle('Edytuj dane kontaktowe');

  const handleEditFaq = (newDescription: string, newContactInfo: string) => {
    updateContactData(newDescription, newContactInfo).then(
      () => {
        openAlert('success', 'Dane zostały pomyślnie zapisane');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <ContactDataEditor
      title="Edytuj dane kontaktowe"
      onCancel={handleClose}
      onSave={handleEditFaq}
      onChange={onChange}
      description={contactDataProp.description}
      contactInfo={contactDataProp.contactInfo}
    />
  );
};
